import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getUnusualEvents(params, signal) {
  return request({
    url: '/events/unusual',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endEventTime'] }),
    signal,
  });
}

export function deleteUnusualEvent(uuid) {
  return request({
    url: `/events/unusual/${uuid}`,
    method: 'delete',
  });
}
